import React, { useMemo } from "react";
import { DisplayTable } from "..";
import { translate } from "../../../../../../../common/providers";
import { getStatusBgColor } from "../../../../../../../common/utils";

function createRow({ label, value, key = label }) {
	return { key, label, value, type: "INFORMATION" };
}

export default function ReqInfoTable({
	attributes,
	category = [],
	clause,
	clientRef,
	criticality,
	documentName,
	documentOuts = [],
	id,
	negotiability,
	type,
}) {
	const attributesStr = useMemo(() => JSON.stringify(attributes ?? {}), [attributes]);
	const categoryStr = useMemo(() => JSON.stringify(category ?? []), [category]);
	const documentOutsStr = useMemo(() => JSON.stringify(documentOuts ?? []), [documentOuts]);

	const rows = useMemo(() => {
		const parsedCategory = JSON.parse(categoryStr);
		const parsedAttributes = JSON.parse(attributesStr);
		const parsedDocumentOuts = JSON.parse(documentOutsStr);

		return [
			createRow({ label: translate("requirement-matrix.req-details.info-table.system-id"), value: id }),
			createRow({ label: translate("requirement-matrix.req-details.info-table.client-ref"), value: clientRef }),
			createRow({ label: translate("requirement-matrix.req-details.info-table.document"), value: documentName }),
			createRow({ label: translate("requirement-matrix.req-details.info-table.clause"), value: clause }),
			createRow({ label: translate("requirement-matrix.req-details.info-table.type"), value: type }),
			createRow({
				label: translate("requirement-matrix.req-details.info-table.negotiability"),
				value: negotiability,
			}),
			createRow({
				label: translate("requirement-matrix.req-details.info-table.criticality"),
				value: criticality,
			}),
			createRow({
				label: translate(translate("common:header.filter.project-categories")),
				value: parsedCategory.map((cat) => cat.name),
			}),
			createRow({
				label: translate("requirement-matrix.req-details.info-table.attributes"),
				value: Object.entries(parsedAttributes).map(([key, value]) => `${key}:${value}`),
			}),
			createRow({
				label: translate("requirement-matrix.req-details.info-table.covered-in-documents"),
				value: parsedDocumentOuts.map((doc) => {
					const covered = doc.covered ? "YES" : "NO";
					const style = { backgroundColor: getStatusBgColor(covered) };
					return { element: doc.name, style };
				}),
			}),
		];
	}, [
		id,
		clientRef,
		documentName,
		clause,
		type,
		negotiability,
		criticality,
		attributesStr,
		categoryStr,
		documentOutsStr,
	]);

	return <DisplayTable rows={rows} />;
}
